import React, { useRef, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function Sidebar() {
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const contentRef1 = useRef(null);
  const contentRef2 = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();

  const toggleDropdown1 = () => {
    setIsOpen1(!isOpen1);
  };

  const toggleDropdown2 = () => {
    setIsOpen2(!isOpen2);
  };

  useEffect(() => {
    if (contentRef1.current) {
      contentRef1.current.style.maxHeight = isOpen1
        ? `${contentRef1.current.scrollHeight}px`
        : "0px";
    }
  }, [isOpen1]);

  useEffect(() => {
    if (contentRef2.current) {
      contentRef2.current.style.maxHeight = isOpen2
        ? `${contentRef2.current.scrollHeight}px`
        : "0px";
    }
  }, [isOpen2]);

  const isAddSchoolActive = [
    "/class-ix-upload-document",
    "/class-ix-regular-student",
    "/class-ix-ex-regular-student",
  ].includes(location.pathname);

  const isReportsActive = [
    "/class-ix-total-registration",
    "/class-ix-checklist-generated",
    "/class-ix-deo-pending",
    "/class-ix-deo-approve",
    "/class-ix-deo-reject",
    "/class-ix-generate-challan",
    "/class-ix-challan-status",
    "/class-ix-consolidated-checklist",
  ].includes(location.pathname);

  const downloadadmit = () => {
    const domain = window.location.origin;
    const districtId = sessionStorage.getItem("district");
    const schoolId = sessionStorage.getItem("schoolCode");

    if (!schoolId) {
      alert("School ID is missing.");
      return;
    }
    if (!districtId) {
      alert("District ID is missing.");
      return;
    }
    const filePath = `${domain}/Admit_cards/${districtId}/${schoolId}.pdf`;
    const link = document.createElement("a");
    link.href = filePath;
    link.download = `Admit-cards-${schoolId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const downloadtr = () => {
    const domain = window.location.origin;
    const classFolder = "class-ix";
    const districtId = sessionStorage.getItem("district");
    const schoolId = sessionStorage.getItem("schoolCode");

    if (!schoolId) {
      alert("School ID is missing.");
      return;
    }
    if (!districtId) {
      alert("District ID is missing.");
      return;
    }
    const filePath = `${domain}/${classFolder}/${districtId}/${schoolId}.pdf`;
    const link = document.createElement("a");
    link.href = filePath;
    link.download = `Tabulation-Register-${schoolId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul className="nav">
        <>
          {sessionStorage.getItem("class9profile") === "YES" && (
            <li
              className={`nav-item ${
                location.pathname === "/class-ix-dashboard" ? "active" : ""
              }`}
            >
              <a
                className="nav-link"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/class-ix-dashboard");
                }}
              >
                <i className="icon-grid menu-icon"></i>
                <span className="menu-title">Dashboard</span>
              </a>
            </li>
          )}
          <li
            className={`nav-item ${
              location.pathname === "/class-ix-school-profile" ? "active" : ""
            }`}
          >
            <a
              className="nav-link"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate("/class-ix-school-profile");
              }}
            >
              <i className="fa fa-university menu-icon"></i>
              <span className="menu-title">School Profile</span>
            </a>
          </li>

          {/* First Dropdown */}
          {sessionStorage.getItem("class9profile") === "YES" && (
            <li className={`nav-item ${isAddSchoolActive ? "active" : ""}`}>
              <a
                className="nav-link"
                onClick={toggleDropdown1}
                style={{ cursor: "pointer" }}
                aria-expanded={isOpen1}
                aria-controls="auth1"
              >
                <i className="icon-head menu-icon"></i>
                <span className="menu-title">Add Student</span>
                <i className="menu-arrow"></i>
              </a>
              <div id="auth1" ref={contentRef1} className="custom-collapse">
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-regular-student");
                      }}
                    >
                      Regular/Private Students
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-ex-regular-student");
                      }}
                      rel="noopener noreferrer"
                    >
                      Ex-Regular Students
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          )}
          {/* Second Dropdown */}
          {sessionStorage.getItem("class9profile") === "YES" && (
            <li className={`nav-item ${isReportsActive ? "active" : ""}`}>
              <a
                className="nav-link"
                onClick={toggleDropdown2}
                style={{ cursor: "pointer" }}
                aria-expanded={isOpen2}
                aria-controls="auth2"
              >
                <i className="fa fa-file menu-icon"></i>
                <span className="menu-title">Reports</span>
                <i className="menu-arrow"></i>
              </a>
              <div id="auth2" ref={contentRef2} className="custom-collapse">
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-total-registration");
                      }}
                      rel="noopener noreferrer"
                    >
                      Total Registration
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-checklist-generated");
                      }}
                      rel="noopener noreferrer"
                    >
                      Checklist Generated
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-deo-pending");
                      }}
                      rel="noopener noreferrer"
                    >
                      Pending at DEO
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-deo-approve");
                      }}
                      rel="noopener noreferrer"
                    >
                      DEO Approved
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-deo-reject");
                      }}
                      rel="noopener noreferrer"
                    >
                      DEO Rejected
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-generate-challan");
                      }}
                      rel="noopener noreferrer"
                    >
                      Generate Challan
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-challan-status");
                      }}
                      rel="noopener noreferrer"
                    >
                      Challan Status
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-consolidated-checklist");
                      }}
                      rel="noopener noreferrer"
                    >
                      List of Registered <br></br>Students
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          )}
          {sessionStorage.getItem("class9profile") === "YES" &&
            sessionStorage.getItem("class9admitcardbutton") === "ON" && (
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    downloadadmit();
                  }}
                >
                  <i className="fa fa-download menu-icon"></i>
                  <span className="menu-title">Download Admit Card</span>
                </a>
              </li>
            )}
          {sessionStorage.getItem("correctionstatus9") === "ON" && (
            <li className="nav-item">
              <a
                className="nav-link"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/class-ix-correct-student");
                }}
              >
                <i class="fa fa-check menu-icon"></i>
                <span className="menu-title ">Correct Student Data</span>
              </a>
            </li>
          )}
          {sessionStorage.getItem("class9profile") === "YES" && (
            <li
              className={`nav-item ${
                location.pathname === "/class-ix-data-not-found" ? "active" : ""
              }`}
            >
              <a
                className="nav-link text-danger"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/class-ix-data-not-found");
                }}
              >
                <i class="fa fa-times menu-icon text-danger"></i>
                <span className="menu-title ">Data Not Found</span>
              </a>
            </li>
          )}

          {sessionStorage.getItem("class9profile") === "YES" && (
            <li
              className={`nav-item ${
                location.pathname === "/class-ix-data-not-found-list"
                  ? "active"
                  : ""
              }`}
            >
              <a
                className="nav-link text-danger"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/class-ix-data-not-found-list");
                }}
              >
                <i class="fa fa-list menu-icon text-danger"></i>
                <span className="menu-title " style={{ fontSize: "13px" }}>
                  Status of Data Not Found
                </span>
              </a>
            </li>
          )}
          {sessionStorage.getItem("tabulationReg") === "ON" && (
            <li className="nav-item blink-text" style={{ padding: "1px 6px" }}>
              <a
                className="nav-link color btn btn-danger text-white"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  downloadtr();
                }}
                style={{
                  backgroundColor: "#dc3545",
                  padding: "8px 12px",
                  borderRadius: "3px",
                }}
              >
                <i className="fa fa-download menu-icon text-white"></i>
                <span className="menu-title" style={{ fontSize: "12px" }}>
                  TABULATION REGISTER
                </span>
              </a>
            </li>
          )}
        </>
      </ul>
    </nav>
  );
}

export default Sidebar;
